import { Component, Input } from "@angular/core";
import { BusinessData } from "src/app/meta/BusinessData.interface";

@Component({
    selector: "ow-order-summary-business-data",
    templateUrl: "./order-summary-business-data.component.html"
})
export class OrderSummaryBusinessDataComponent {

    @Input() businessData!: BusinessData

}
